module.exports = __webpack_public_path__ + "static/img/jg.84442dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jg.png
// module id = picz
// module chunks = 1